import { atom, useAtom } from 'jotai';

const canBodyScrollAtom = atom<boolean>(true);

export const useCanBodyScrollAtom = () => {
	return useAtom(canBodyScrollAtom);
};
